import module from 'module';
import './general-health-check.component.less';
import templateUrl from './general-health-check.template.html';

class GeneralHealthCheck {}

module.component('generalHealthCheck', {
  templateUrl,
  bindings: {
    checks: '<',
    hideOk: '<'
  },
  controller: GeneralHealthCheck
});